<script>
  import Countdown from '@/scripts/old/classes/Countdown';
  import DECLS from '@/scripts/old/common/decls';
  import { declOfNums } from '@/scripts/old/helpers/utils';

  export default {
    props: {
      timestamp: {
        type: [String, Number],
        required: true,
      },
      doneText: {
        type: String,
        default: 'Время истекло',
      },
    },
    data() {
      return {
        countdown: null,
        value1: null,
        value2: null,
        label1: null,
        label2: null,
        done: false,
      };
    },
    watch: {
      timestamp() {
        this.countdown.destroy();
        this.countdown = null;
        this.init();
      },
    },
    mounted() {
      this.init();
    },
    methods: {
      update(offset) {
        // Month and days
        if (offset.months) {
          this.value1 = `0${offset.months}`.slice(-2);
          this.value2 = `0${offset.days}`.slice(-2);
          this.label1 = declOfNums(offset.months, DECLS.months);
          this.label2 = declOfNums(offset.days, DECLS.days);
          this.countdown.destroy();
          return;
        }

        // Days and hours
        if (!offset.months && offset.days) {
          this.value1 = `0${offset.days}`.slice(-2);
          this.value2 = `0${offset.hours}`.slice(-2);
          this.label1 = declOfNums(offset.days, DECLS.days);
          this.label2 = declOfNums(offset.hours, DECLS.hours);
          this.countdown.destroy();
          return;
        }

        // Hours and minutes
        if (!offset.months && !offset.days && offset.hours) {
          this.value1 = `0${offset.hours}`.slice(-2);
          this.value2 = `0${offset.minutes}`.slice(-2);
          this.label1 = declOfNums(offset.hours, DECLS.hours);
          this.label2 = declOfNums(offset.minutes, DECLS.minutes);
          return;
        }

        this.value1 = `0${offset.minutes}`.slice(-2);
        this.value2 = `0${offset.seconds}`.slice(-2);
        this.label1 = declOfNums(offset.minutes, DECLS.minutes);
        this.label2 = declOfNums(offset.seconds, DECLS.seconds);
      },
      init() {
        this.countdown = new Countdown(this.timestamp, {
          onUpdate: (offset) => {
            this.update(offset);
          },
          onComplete: () => {
            this.done = true;
          },
        });
        this.countdown.start();
      },
    },
  };
</script>

<template>
  <div
    :class="{ 'is-done': done }"
    class="countdown"
  >
    <div class="countdown__inner">
      <div
        v-if="done"
        class="countdown__done"
      >
        {{ doneText }}
      </div>
      <div class="countdown__block">
        <div class="countdown__board">
          <span class="countdown__value">{{ value1 }}</span>
        </div>
        <div class="countdown__label">
          {{ label1 }}
        </div>
      </div>
      <div class="countdown__sep">
        :
      </div>
      <div class="countdown__block">
        <div class="countdown__board">
          <span class="countdown__value">{{ value2 }}</span>
        </div>
        <div class="countdown__label">
          {{ label2 }}
        </div>
      </div>
    </div>
  </div>
</template>
